import mixpanel from "mixpanel-browser";
import { AnalyticsEventBus, event } from "../analytics";

export class BillingSettingMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.billingSetting.setting_upgrade_button_enter_promocode, (data) => {
      mixpanel.track(event.billingSetting.setting_upgrade_button_enter_promocode, { ...data });
    });
    AnalyticsEventBus.$on(event.billingSetting.setting_upgrade_modal_promocode_button_use_promocode, (data) => {
      mixpanel.track(event.billingSetting.setting_upgrade_modal_promocode_button_use_promocode, { ...data });
    });
    AnalyticsEventBus.$on(event.billingSetting.subscription, (data) => {
      mixpanel.track(event.billingSetting.subscription, { ...data });
    });
    AnalyticsEventBus.$on(event.billingSetting.subscription_button_next_to_payment_method, (data) => {
      mixpanel.track(event.billingSetting.subscription_button_next_to_payment_method, { ...data });
    });
    AnalyticsEventBus.$on(event.billingSetting.subscription_button_confirm_payment, (data) => {
      mixpanel.track(event.billingSetting.subscription_button_confirm_payment, { ...data });
    });
  }
}
